module.exports = __webpack_public_path__ + "static/media/video-interior-2.28ed7bfe.mp4";